<app-draggable-modal-wrapper>
    <h2
        mat-dialog-title
        modal-drag-handle
        class="!text-2xl !font-normal !text-primary-700 !mb-2"
    >
        Add Credit Card
    </h2>
    <hr />
    <mat-dialog-content class="ps-6 pt-2 mat-typography">
        @if (displayDuplicatePaymentInformationError()) {
            <div
                class="w-full p-3 flex flex-row space-x-3 border border-error-600 bg-error-50 rounded-md mb-4"
            >
                <mat-icon class="text-error-600">error</mat-icon>
                <span class="text-base text-error-600 font-medium">
                    {{
                        createCardOnFileValidationMessages.duplicatePaymentInformation
                    }}
                </span>
            </div>
        }

        <form [formGroup]="form" class="flex flex-col space-y-5">
            <div
                class="w-full flex flex-col space-y-3 border border-black rounded-md p-4"
            >
                <h3 mat-card-subtitle class="!text-primary-700 !mb-2">
                    Billing Address
                </h3>

                <div class="w-full flex flex-row space-x-3">
                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="flex-1"
                    >
                        <mat-label>First Name</mat-label>
                        <input
                            title="First Name"
                            matInput
                            [formControl]="form.controls.firstName"
                            [maxLength]="
                                cardOnFileFormConstants.FIRST_NAME_MAX_LENGTH
                            "
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                        />
                    </mat-form-field>
                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="flex-1"
                    >
                        <mat-label>Last Name</mat-label>
                        <input
                            title="Last Name"
                            matInput
                            [formControl]="form.controls.lastName"
                            [maxLength]="
                                cardOnFileFormConstants.LAST_NAME_MAX_LENGTH
                            "
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                        />
                    </mat-form-field>
                </div>
                <div class="w-full flex flex-row space-x-3">
                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="flex-1"
                    >
                        <mat-label>Company</mat-label>
                        <input
                            title="Company"
                            matInput
                            [formControl]="form.controls.company"
                            [maxLength]="
                                cardOnFileFormConstants.COMPANY_MAX_LENGTH
                            "
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                        />
                    </mat-form-field>
                    <div class="flex-1"></div>
                </div>
                <div class="w-full flex flex-row space-x-3">
                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="flex-1"
                    >
                        <mat-label>Street</mat-label>
                        <input
                            title="Street"
                            matInput
                            [formControl]="form.controls.address"
                            [maxLength]="
                                cardOnFileFormConstants.ADDRESS_MAX_LENGTH
                            "
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                        />
                    </mat-form-field>
                    <div class="flex-1"></div>
                </div>
                <div class="w-full flex flex-row space-x-3">
                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="w-5/12"
                    >
                        <mat-label>City</mat-label>
                        <input
                            title="City"
                            matInput
                            [formControl]="form.controls.city"
                            [maxLength]="
                                cardOnFileFormConstants.CITY_MAX_LENGTH
                            "
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                        />
                    </mat-form-field>
                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="w-5/12"
                    >
                        <mat-label>State</mat-label>
                        <mat-select
                            [formControl]="form.controls.state"
                            appSelectTypeahead
                        >
                            @for (
                                stateCode of stateCodeOptions;
                                track stateCode.value
                            ) {
                                <mat-option [value]="stateCode.value">
                                    {{ stateCode.label }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="w-2/12"
                    >
                        <mat-label>Zip Code</mat-label>
                        <input
                            title="Zip Code"
                            matInput
                            [formControl]="form.controls.zip"
                            [imask]="maskOptions.postalCode"
                            [unmask]="true"
                            [pattern]="regExPattern.PostalCode"
                        />
                    </mat-form-field>
                </div>
            </div>
            <div
                class="w-full flex flex-col space-y-3 border border-black rounded-md p-4"
            >
                <h3 mat-card-subtitle class="!text-primary-700 !mb-2">
                    Credit Card
                </h3>

                <div class="w-full flex flex-row space-x-3">
                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="w-4/12"
                    >
                        <mat-label>Card Number</mat-label>
                        <input
                            title="Card Number"
                            matInput
                            [formControl]="form.controls.cardNumber"
                            [imask]="maskOptions.creditCard"
                            [unmask]="true"
                        />
                        @if (getCardNumberError(); as error) {
                            <mat-error>{{ error }}</mat-error>
                        }
                    </mat-form-field>

                    <app-card-type-icon
                        class="flex"
                        [cardType]="getCardTypeFromNumber()"
                    />
                </div>

                <div class="w-full flex flex-row items-start space-x-3">
                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="w-3/12"
                    >
                        <mat-label>Expiration Month</mat-label>
                        <mat-select
                            [formControl]="form.controls.expirationMonth"
                        >
                            @for (
                                monthOption of monthOptions;
                                track monthOption.value
                            ) {
                                <mat-option [value]="monthOption.value">{{
                                    monthOption.label
                                }}</mat-option>
                            }
                        </mat-select>
                        @if (getExpirationMonthError(); as error) {
                            <mat-error>{{ error }}</mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="w-3/12"
                    >
                        <mat-label>Expiration Year</mat-label>
                        <mat-select
                            [formControl]="form.controls.expirationYear"
                        >
                            @for (
                                yearOption of yearOptions;
                                track yearOption.value
                            ) {
                                <mat-option [value]="yearOption.value">{{
                                    yearOption.label
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="w-full">
                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="w-3/12"
                    >
                        <mat-label>Security Code</mat-label>
                        <input
                            title="Security Code"
                            matInput
                            [type]="showCardCode ? 'text' : 'password'"
                            [formControl]="form.controls.cardCode"
                            [appRegexInput]="regExPattern.NumericOnly"
                            [minlength]="
                                cardOnFileFormConstants.CARD_CODE_MASTERCARD_VISA_LENGTH
                            "
                            [maxlength]="
                                cardOnFileFormConstants.CARD_CODE_AMEX_LENGTH
                            "
                        />
                        <button
                            type="button"
                            mat-icon-button
                            matSuffix
                            [attr.aria-label]="
                                showCardCode
                                    ? 'Hide security code'
                                    : 'Show security code'
                            "
                            (click)="toggleCardCodeVisibility()"
                        >
                            <mat-icon>
                                {{
                                    showCardCode
                                        ? 'visibility_off'
                                        : 'visibility'
                                }}
                            </mat-icon>
                        </button>
                        @if (getCardCodeError(); as error) {
                            <mat-error>{{ error }}</mat-error>
                        }
                    </mat-form-field>
                </div>

                <div class="w-full flex flex-col space-y-1">
                    @if (displayStoreForFutureUseOption()) {
                        <mat-checkbox
                            color="primary"
                            [formControl]="form.controls.storeForFutureUse"
                        >
                            <span class="text-base font-medium">
                                Store this credit card on file for future use.
                            </span>
                        </mat-checkbox>
                    }
                    @if (displayIsDefaultOption()) {
                        <mat-checkbox
                            color="primary"
                            [formControl]="form.controls.isDefault"
                        >
                            <span class="text-base font-medium"
                                >Use as default card for credit card
                                payments.</span
                            >
                        </mat-checkbox>
                    }
                </div>
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="!pb-5 !pr-5">
        <button
            type="button"
            mat-stroked-button
            color="primary"
            class="!border-primary-700"
            (click)="onCancel()"
        >
            Cancel
        </button>
        <button
            mat-raised-button
            type="button"
            name="Save"
            cdkFocusInitial
            color="primary"
            [disabled]="form.invalid"
            (click)="onSave()"
        >
            Save
        </button>
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
